<div class="actionpopuup">
  <h3>{{ 'GEOFENCE_DELETETITLE' | translation }}</h3>
  <span>{{ 'GEOFENCE_DELETECONFIRM' | translation }}</span>
  <div class="actions">
    <button mat-raised-button class="outlined-button" type="button" (click)="deletGeofence(id.gid)"> {{ 'YES' | translation }} </button>
    <button mat-raised-button class="outlined-button" type="button" [mat-dialog-close]="false"> {{ 'NO' | translation }} </button>
  </div>
</div>
